import styled, { css } from "styled-components";

export const TableComponentWrapper = styled.div`
  display: flex;
  flex-direction: Column;
  background: var(--fd-colors-background-surface);

  > :nth-child(3) {
    font-weight: 500;
  }

  > :last-child {
    box-shadow: none;
  }

  @media only screen and (max-width: 599px) {
    width: calc(100vw - 24px);
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    position: relative;

    ::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
  }

  @media only screen and (max-width: 688px) {
    > div:last-child {
      border-bottom: none;
    }
  }

  @media only screen and (min-width: 768px) {
    padding-top: 32px;
  }

  @media only screen and (max-width: 767px) {
    padding-top: 20px;
  }
`;

export const ScrollableIndicator = styled.div<{ length: number }>`
  @media only screen and (max-width: 499px) {
    ${(props) => css`
      top: calc(${props.length} * 48px);
      margin-top: calc(${props.length} * -48px);
      height: calc(${props.length} * 48px);
    `}
    left: calc(100% - 24px);
    width: 24px;
    position: sticky;
    background: linear-gradient(
      90deg,
      var(--fd-colors-background-gradient-color-stops-start) 0%,
      var(--fd-colors-background-gradient-color-stops-end) 100%
    );
  }
`;
